<div>
    <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>

<form *ngIf="displayForm" (keydown.enter)="handleEnter($event)" #userForm="ngForm" name="userForm" (ngSubmit)="submit()">
    <h4 *ngIf="mode === 'add'">Add User</h4>
    <h4 *ngIf="mode === 'update'">Edit User</h4>
    <div class="row mx-0">
        <div class="col-9">
            <div class="row mb-2">
                <span class="ps-0 col-3 fw-bold">Account ID: {{ account.accountId }}</span>
                <div class="ps-0 col-9 fw-bold truncate" tooltipPosition="top"
                    [pTooltip]="account.company ? account.company : ''" appShowToolTipIfTruncated>Organization Name: {{
                    account.company }}</div>
                <span *ngIf="mode === 'update'" class="ps-0 col-3 fw-bold">User ID: {{ userProfile.userName }}</span>
            </div>
            <div class="row">
                <div class="mb-3 ps-0 col-5">
                    <label for="role" class="required">Role</label>

                    <p-multiSelect [(ngModel)]="userProfile.roleList" id="role" appTid class="p-formcontrol"
                        selectedItemsLabel="{0} items selected" #role="ngModel" name="role"
                        placeholder="Nothing Selected" [required]="true" [options]="userRoles" [showToggleAll]="false"
                        [styleClass]="role!.invalid && userForm.submitted ? 'field-errors' : ''"
                        [maxSelectedLabels]="2">
                        <ng-template let-role pTemplate="item">
                            <div [ngSwitch]="role.value">
                                <span *ngSwitchDefault>{{role.label}}</span>
                            </div>
                        </ng-template>
                    </p-multiSelect>
                    <ng-container *ngIf="role.errors && userForm.submitted">
                        <span *ngIf="role.errors?.required" class="failed">Role is required.</span>
                    </ng-container>
                    <ng-container *ngIf="role.errors && userForm.submitted">
                        <span *ngIf="role.errors?.invalid" class="failed">{{role.errors.invalid}}</span>
                    </ng-container>
                </div>
            </div>

            <div class="row">
                <div class="mb-3 ps-0 col-4">
                    <label for="firstName" class="required">First Name</label>
                    <input appScrText [(ngModel)]="userProfile.firstName" name="firstName" #firstName="ngModel"
                        placeholder="First Name" id="firstName" required maxlength="{{MaxLen.FirstName}}"
                        appFirstNameValidator [ngClass]="{'error-input': firstName.errors && userForm.submitted}" />
                    <app-error-msg [field]="firstName" [fieldLabel]="'First Name'" [form]="userForm"></app-error-msg>
                </div>
                <div class="mb-3 ps-0 offset-2 col-5">
                    <label for="lastName" class="required">Last Name</label>
                    <input appScrText [(ngModel)]="userProfile.lastName" name="lastName" #lastName="ngModel"
                        placeholder="Last Name" id="lastName" required maxlength="{{MaxLen.LastName}}"
                        appLastNameValidator [ngClass]="{'error-input': lastName.errors && userForm.submitted}" />
                    <app-error-msg [field]="lastName" [fieldLabel]="'Last Name'" [form]="userForm"></app-error-msg>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 ps-0 col-4">
                    <label for="phoneInput" class="required">Phone Number</label>
                    <app-phone [(ngModel)]="userProfile.phone" #phone="ngModel" class="col-12" required name="phone" id="phone"></app-phone>
                    <app-error-msg [field]="phone" [fieldLabel]="'Phone Number'" [form]="userForm"></app-error-msg>
                </div>
                <div class="mb-3 ps-0 col-2">
                    <label for="phoneExtension">Extension</label>
                    <input appScrText [(ngModel)]="userProfile.phoneExtension" name="phoneExtension" id="phoneExtension"
                        maxlength="{{MaxLen.PhoneExtension}}" #phoneExtension="ngModel"
                        [ngClass]="{'error-input': phoneExtension.errors && userForm.submitted}" />
                    <ng-container *ngIf="phoneExtension.errors && userForm.submitted">
                        <span *ngIf="phoneExtension.errors?.invalid"
                            class="failed">{{phoneExtension.errors.invalid}}</span>
                    </ng-container>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 ps-0 col-5">
                    <label for="email" class="required">Email</label>
                    <input appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" appEmail [(ngModel)]="userProfile.email" name="email" placeholder="Email"
                        id="email" required maxlength="{{MaxLen.Email}}"
                        [ngClass]="{'error-input': email.errors && userForm.submitted}" #email="ngModel" />
                    <app-error-msg [field]="email" [fieldLabel]="'Email'" [form]="userForm"></app-error-msg>
                </div>
                <div class="mb-3 offset-1 col-5 ps-0">
                    <label for="confirmEmail" [ngClass]="{required: userForm?.controls?.email?.dirty === true }">Confirm
                        Email
                        Address</label>
                    <input appPublicDomainEmailValidator [publicEmailDomains]="publicEmailDomains" #confirmEmail="ngModel" class="form-text form-control"
                        [(ngModel)]="userProfile.confirmEmail" name="confirmEmail" placeholder="Confirm Email Address"
                        id="confirmEmail" [required]="userForm?.controls?.email?.dirty === true"
                        maxlength="{{MaxLen.Email}}" />
                    <app-error-msg [field]="confirmEmail" [fieldLabel]="'Confirm Email Address'"
                        [form]="userForm"></app-error-msg>
                </div>
            </div>

            <div class="row">
                <div class="mb-3 ps-0 col-4">
                    <label for="country" class="required">Country</label>
                    <app-country-dropdown [(ngModel)]="userProfile.country" name="country" #country="ngModel"
                        id="country">
                    </app-country-dropdown>
                    <app-error-msg [form]="userForm" [field]="country" fieldLabel="Country"></app-error-msg>
                </div>
            </div>
            <div class="row">
                <div class="mb-3 ps-0 col-11">
                    <label for="companyAddress1" class="required">Organization Address 1</label>
                    <input appScrText [(ngModel)]="userProfile.address1" name="companyAddress1"
                        placeholder="Organization Address 1" id="companyAddress1" required maxlength="{{MaxLen.Address}}"
                        [ngClass]="{'error-input': companyAddress1.errors && userForm.submitted}"
                        #companyAddress1="ngModel" />
                    <app-error-msg [field]="companyAddress1" [fieldLabel]="'Organization Address 1'"
                        [form]="userForm"></app-error-msg>
                </div>
            </div>
            <div class="row">
                <div class="mb-3  ps-0 col-11">
                    <label for="companyAddress2">Organization Address 2</label>
                    <input appScrText [(ngModel)]="userProfile.address2" name="address2" placeholder="Organization Address 2"
                        id="companyAddress2" maxlength="{{MaxLen.Address}}" #address2="ngModel" />
                </div>
            </div>
            <div class="row">
                <div class="col-11">
                    <div class="row">
                        <div class="mb-3  ps-0 col-4">
                            <label for="city" class="required">City</label>
                            <input appScrText [(ngModel)]="userProfile.city" name="city" placeholder="City" id="city"
                                required maxlength="{{MaxLen.City}}" #city="ngModel"
                                [ngClass]="{'error-input': city.errors && userForm.submitted}" />
                            <app-error-msg [field]="city" [fieldLabel]="'City'" [form]="userForm"></app-error-msg>
                        </div>
                        <div class="mb-3  ps-0 col-4">
                            <label for="state"
                                [ngClass]="{required: userProfile.country === 'ca' || userProfile.country === 'us'}">
                                State/Province
                            </label>
                            <app-region-dropdown #stateModel="ngModel" name="state" id="state"
                                [(ngModel)]="userProfile.state" [country]="userProfile.country">
                            </app-region-dropdown>
                            <app-error-msg [field]="stateModel" fieldLabel="State/Province"
                                [form]="userForm"></app-error-msg>
                        </div>
                        <div class="mb-3  ps-0 c
                        ol-4">
                            <label for="zipInput"
                                [ngClass]="{required: userProfile.country === 'us' || userProfile.country === 'ca'}">Zip/Postal
                                Code</label>

                            <app-zipcode-input name="zip" id="zip" inputId="zipInput" [(ngModel)]="userProfile.zip"
                                [country]="userProfile.country" #zip="ngModel">
                            </app-zipcode-input>
                            <app-error-msg [field]="zip" fieldLabel="Zip/Postal Code" [form]="userForm"></app-error-msg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col p-0">
                    <h5>Email Subscriptions</h5>
                    <div class="mb-2">Select the user's email message category subscriptions:</div>
                    <div *ngFor="let category of emailCategories">
                        <label for="{{category.name}}">
                            <p-checkbox value="{{category.name}}" [(ngModel)]="userProfile.emailCategoryList"
                                name="{{category.name}}" inputId="{{category.name}}" label="{{ category.description }}"
                                [disabled]="subscriptionsDisabled()"></p-checkbox>
                        </label>
                    </div>
                </div>
            </div>

            <br>
            <div class="row">
                <button *ngIf="mode === 'add'" class="col-auto btn btn-primary  px-4 mb-2" submit>Save User</button>
                <button *ngIf="mode === 'update'" class="col-auto btn btn-primary  px-4 mb-2" submit>Update
                    User</button>
                <button class="col-auto btn btn-secondary px-4 mb-2 ms-2" type="button"
                    (click)="confirmCancelDialog()">Cancel</button>
            </div>
        </div>
    </div>
</form>

<p-confirmDialog key='confirmCancel' #creditFormCancel width="425" [closable]="false">
    <p-footer>
        <button i18n id="scaccept" class="btn btn-primary me-2" type="button"
            (click)="creditFormCancel.accept()">Yes</button>
        <button i18n id="screject" class="btn btn-secondary" type="button"
            (click)="creditFormCancel.reject()">No</button>
    </p-footer>
</p-confirmDialog>